import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_MANDATE_BY_ID } from "../Schema/Mandate";

export const useGetMandateById = ({ id }) => {
  const [loading, setLoading] = useState(true);
  const [mandateData, setMandateData] = useState([]);

  const { refetch } = useQuery(GET_MANDATE_BY_ID, {
    variables: {
      id: id,
    },
    onCompleted: ({ getMandateById }) => {
      setMandateData(getMandateById || []);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  return { mandateData, loading, refetch };
};
